module.exports = __webpack_public_path__ + "static/media/fa-solid-900.3997dfc8.svg";